<template>
  <div id="home" class="punish_week">
    <div class="title_week">{{ title }}</div>
    <div class="time">{{ created_at }}</div>
    <div class="text" v-if="!length">{{ content }}</div>
    <div v-if="length">
      <div class="text" v-for="item in content" :key="item">
        <img :src="item.content" v-if="item.type == 'img'" alt />
        <p v-else>{{ item.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { weekDetail, getDetail,getCode } from "@/proxy/index";

export default {
  data() {
    return {
      languageList: ["en"],
      inviteCode: "invite",
      showMask: false,
      index: "",
      id: "",
      title: "",
      content: "",
      length: false,
      errCode: {},
    };
  },
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  mounted() {
    document.querySelector("#loadingMask").style.display = "none";
    //取消请求
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.getList();
    this.getCode();
  },
  methods: {
    getCode(lang) {
      getCode(window.localStorage.getItem("selfservicelang")).then((res) => {
        (res.data.errcode || []).map((item) => {
          this.errCode[item.code] = item.lang || "";
        });
      });
    },
    getList() {
      getDetail(
        window.localStorage.getItem("selfservicelang"),
        this.type,
        this.id
      ).then((res) => {
        if (res.data.code == 0) {
          this.data = res.data.data;
          this.title = res.data.data.title;
          this.created_at = res.data.data.created_at;
          if (typeof res.data.data.content != "string") {
            this.length = true;
            this.content = res.data.data.content;
          } else {
            this.length = false;
            this.content = res.data.data.content;
          }
          console.log(this.content);
        } else {
          layer.open({
            content: this.errCode[res.data.code] || res.data.code,
            skin: "msg",
            time: 2,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/views/punish_week.scss";
</style>
